export default __webpack_public_path__ + "static/intro-img-beb39cf0afc55949e4b60c5bdfdb11f3.jpeg";